/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import {
  Signer,
  utils,
  Contract,
  ContractFactory,
  BigNumberish,
  Overrides,
} from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Registry, RegistryInterface } from "../../contracts/Registry";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IERC20",
        name: "_stakingToken",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_stakingCost",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_supportCost",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "ArgumentInvalid",
    type: "error",
  },
  {
    inputs: [],
    name: "NoServerURLSet",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    name: "ProtocolDoesNotExist",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    name: "ProtocolExists",
    type: "error",
  },
  {
    inputs: [],
    name: "ServerURLInvalid",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "TokenDoesNotExist",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "TokenExists",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes4[]",
        name: "protocols",
        type: "bytes4[]",
      },
    ],
    name: "AddProtocols",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address[]",
        name: "tokens",
        type: "address[]",
      },
    ],
    name: "AddTokens",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bytes4[]",
        name: "protocols",
        type: "bytes4[]",
      },
    ],
    name: "RemoveProtocols",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        indexed: false,
        internalType: "address[]",
        name: "tokens",
        type: "address[]",
      },
    ],
    name: "RemoveTokens",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        indexed: false,
        internalType: "string",
        name: "url",
        type: "string",
      },
    ],
    name: "SetServerURL",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        indexed: false,
        internalType: "string",
        name: "url",
        type: "string",
      },
      {
        indexed: false,
        internalType: "bytes4[]",
        name: "protocols",
        type: "bytes4[]",
      },
      {
        indexed: false,
        internalType: "address[]",
        name: "tokens",
        type: "address[]",
      },
    ],
    name: "UnsetServer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "bytes4[]",
        name: "_protocols",
        type: "bytes4[]",
      },
    ],
    name: "addProtocols",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_tokens",
        type: "address[]",
      },
    ],
    name: "addTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_staker",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_staker",
        type: "address",
      },
    ],
    name: "getProtocolsForStaker",
    outputs: [
      {
        internalType: "bytes4[]",
        name: "_protocolList",
        type: "bytes4[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "_protocol",
        type: "bytes4",
      },
    ],
    name: "getServerURLsForProtocol",
    outputs: [
      {
        internalType: "string[]",
        name: "_urls",
        type: "string[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_stakers",
        type: "address[]",
      },
    ],
    name: "getServerURLsForStakers",
    outputs: [
      {
        internalType: "string[]",
        name: "_urls",
        type: "string[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
    ],
    name: "getServerURLsForToken",
    outputs: [
      {
        internalType: "string[]",
        name: "urls",
        type: "string[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "_protocol",
        type: "bytes4",
      },
    ],
    name: "getStakersForProtocol",
    outputs: [
      {
        internalType: "address[]",
        name: "_stakers",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
    ],
    name: "getStakersForToken",
    outputs: [
      {
        internalType: "address[]",
        name: "_stakers",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_staker",
        type: "address",
      },
    ],
    name: "getTokensForStaker",
    outputs: [
      {
        internalType: "address[]",
        name: "tokenList",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4[]",
        name: "_protocols",
        type: "bytes4[]",
      },
    ],
    name: "removeProtocols",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "_tokens",
        type: "address[]",
      },
    ],
    name: "removeTokens",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "_url",
        type: "string",
      },
    ],
    name: "setServerURL",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    name: "stakerServerURLs",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "stakingCost",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "stakingToken",
    outputs: [
      {
        internalType: "contract IERC20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "supportCost",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_staker",
        type: "address",
      },
      {
        internalType: "bytes4",
        name: "_protocol",
        type: "bytes4",
      },
    ],
    name: "supportsProtocol",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_staker",
        type: "address",
      },
      {
        internalType: "address",
        name: "_token",
        type: "address",
      },
    ],
    name: "supportsToken",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "unsetServer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type RegistryConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: RegistryConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class Registry__factory extends ContractFactory {
  constructor(...args: RegistryConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    _stakingToken: string,
    _stakingCost: BigNumberish,
    _supportCost: BigNumberish,
    overrides?: Overrides & { from?: string }
  ): Promise<Registry> {
    return super.deploy(
      _stakingToken,
      _stakingCost,
      _supportCost,
      overrides || {}
    ) as Promise<Registry>;
  }
  override getDeployTransaction(
    _stakingToken: string,
    _stakingCost: BigNumberish,
    _supportCost: BigNumberish,
    overrides?: Overrides & { from?: string }
  ): TransactionRequest {
    return super.getDeployTransaction(
      _stakingToken,
      _stakingCost,
      _supportCost,
      overrides || {}
    );
  }
  override attach(address: string): Registry {
    return super.attach(address) as Registry;
  }
  override connect(signer: Signer): Registry__factory {
    return super.connect(signer) as Registry__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): RegistryInterface {
    return new utils.Interface(_abi) as RegistryInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Registry {
    return new Contract(address, _abi, signerOrProvider) as Registry;
  }
}
